module.exports = __webpack_public_path__ + "static/media/aws-white.8f6730a0.svg";